import { z } from 'zod';
export const BuildingListItemSchema = z.object({
    name: z.string(),
    areaId: z.number().int().nullable(),
    areaName: z.string().nullable(),
    unitCount: z.number().int().nonnegative(),
});
export const BuildingListQuerySchema = z.object({
    q: z.string().optional(),
    area_id: z.coerce.number().int().optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    sort: z.enum(['name', 'units_desc']).default('name'),
});
//# sourceMappingURL=building.js.map